<shell-layout *ngIf="config" [error_identity]="true">
  <div class="identity__container">
    <img class="error__img" src="assets/img/errors/error__document_identification.svg" alt="" />

    <ui-text class="error__title" color="blue-500" size="h3" weight="semibold">
      {{ config.errorTitle }}
    </ui-text>

    <ui-text class="error__description" color="blue-300">
      <div>
        <span class="desktop" [innerHTML]="config.errorDescription"> </span>
        <span class="mobile" [innerHTML]="config.errorDescriptionMobile"> </span>
      </div>
    </ui-text>

    <ui-button
      (clicked)="closeModal()"
      class="error__action"
      type="primary"
      label="Reintentar"
    ></ui-button>
  </div>
</shell-layout>
